import React, { Component } from "react";
import { connect } from "react-redux";
import PageTitle from "../../components/shared/PageTitle";
import Widget from "../../components/shared/Widget";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import CartItem from "../../components/CartItem";

import {
  removeCart,
  incCart,
  decCart,
  updateCartQuantity,
} from "../../store/actions/cart";

import styles from "../../thema/style";
import CheckoutCart from "../../components/CheckoutCart";

class CartDetail extends Component {
  render() {
    const cartTotalPrice =
      this.props.cart.items.length > 0
        ? parseFloat(
            this.props.cart.items
              .map((v) =>
                v.sale_price ? v.quantity * v.sale_price : v.quantity * v.price
              )
              .reduce((a, b) => a + b)
              .toFixed(2)
          )
        : 0;

    return (
      <React.Fragment>
        <PageTitle title={"Sepet Detayları"} />
        <div className="row">
          <div className={"container"}>
            <div className="row">
              <div className={"col-md-9"}>
                <div
                  className={"row"}
                  style={{ marginTop: 10, marginBottom: 50 }}
                >
                  {/* <table className={styles.cartDetail}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>RESİM</th>
                        <th>ÜRÜN ADI</th>
                        <th className="product-price">BİRİM FİYATI</th>
                        <th>MİKTAR</th>
                        <th className="product-subtotal">TOPLAM</th>
                        <th className="product-remove">&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.cart.items.map((item, i) => (
                        <CartItem
                          key={i}
                          product={item}
                          updateCartQuantity={(quantity) => {
                            this.props.updateCartQuantity(item, quantity);
                          }}
                          removeCart={() => {
                            this.props.removeCart(item);
                          }}
                          incCart={() => {
                            this.props.incCart(item);
                          }}
                          decCart={() => {
                            this.props.decCart(item);
                          }}
                        />
                      ))}
                    </tbody>
                  </table> */}
                  <CheckoutCart header={false} {...this.props} />

                  {this.props.cart.items.length == 0 ? (
                    <React.Fragment>
                      <div style={{ width: "100%" }}>
                        <h3 className="text-center">
                          Sepetinde ürün bulunmamaktadır.
                        </h3>
                      </div>
                      <br />
                      <br />
                    </React.Fragment>
                  ) : null}

                  <button
                    disabled={this.props.cart.items.length == 0}
                    className="btn btn-success"
                    onClick={(e) => {
                      e.preventDefault();
                      if (this.props.customer.customer) {
                        this.props.history.push({ pathname: "/odeme" });
                      } else {
                        this.props.history.push({
                          pathname: "/odeme/giris",
                        });
                      }
                    }}
                    type={"button"}
                  >
                    {this.props.cart.items.length == 0
                      ? "Alışverişe Devam Etmek İçin Sepetinize Ürün Ekleyiniz"
                      : "Alışverişi Tamamla"}
                  </button>
                </div>
              </div>
              <div className={"col-md-3"}>
                {/* <Widget title={"SİPARİŞ ÖZETİ"}>
                  <div className={styles.orderSummary}>
                    <ul>
                      <li>
                        <strong>
                          Toplam{" "}
                          {this.props.cart.items.length > 0
                            ? this.props.cart.items
                                .map((v) => v.quantity)
                                .reduce((a, b) => a + b)
                            : 0}{" "}
                          Ürün
                        </strong>
                      </li>
                      <li>
                        Ara Toplam
                        <span> ₺{cartTotalPrice}</span>
                      </li>
                      {cartTotalPrice > 0 ? (
                        <li>
                          Kargo
                          <span>
                            {" "}
                            ₺{this.props.setting.setting.shipping_cost}
                          </span>
                        </li>
                      ) : null}
                      <li className={"sperator"} />
                      <li>
                        Toplam
                        <span>
                          {" "}
                          ₺
                          {cartTotalPrice > 0
                            ? cartTotalPrice +
                              (cartTotalPrice >=
                              this.props.setting.setting.free_shipping
                                ? 0
                                : this.props.setting.setting.shipping_cost)
                            : 0}
                        </span>
                      </li>
                    </ul>
                    <div className={"text-right"}>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          if (this.props.customer.customer) {
                            this.props.history.push({ pathname: "/odeme" });
                          } else {
                            this.props.history.push({
                              pathname: "/odeme/giris",
                            });
                          }
                        }}
                        className="btn btn-success"
                        type={"button"}
                        disabled={this.props.cart.items.length == 0}
                      >
                        Alışverişi Tamamla
                      </button>
                    </div>
                  </div>
                </Widget> */}
                <CategoriesWidget />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ cart, customer, setting }) => {
  return { cart, customer, setting };
};

const mapDispatchToProps = { removeCart, incCart, decCart, updateCartQuantity };

export default connect(mapStateToProps, mapDispatchToProps)(CartDetail);



// WEBPACK FOOTER //
// ./src/routers/CartDetail/index.js